import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/researchers/_authenticated/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/researchers/settings/details', replace: true });
  },
});
